import React from "react";
import shubham from "./shubham.webp";
import "./blogs.css";

const Shubham = () => {
  return (
    <div className="blog">
      <div className="row blog-row">
        <div className="col-md-4">
          <img
            src= {shubham}
            style={{ height: "315px", width: "90%" }}
            alt="Shubham"
          ></img>
        </div>
        <div className="col-md-8">
          <div className="blog-head">
            <h2>Shubham Kumar</h2>
            <small> Larsen & Toubro Limited</small>
          </div>
        </div>
      </div>
      <div className="container-fluid">
        <div className="row blog-row">
          <div className="col-md-12">
            <h3>Introduction </h3>
            <p>
              “In the grand circus of placements, acing interviews is like
              walking a tightrope with a safety net made of your resume.”
              <br /> Hi, I’m Shubham, and I got placed as a Management Trainee
              at Larsen and Toubro. If you’re confused about what to prepare,
              how to prepare, and where to start, don’t worry; I was in the same
              boat. I faced many ups and downs throughout my semesters, even
              though I made friends, got internships, held positions of
              responsibility till the last semesters, organized a civil
              engineering conclave (Sankalan), got placement, and created
              lasting memories. Even though things didn’t always go as planned,
              I managed to find opportunities for myself. This blog is about my
              thoughts and placement journey. Placements might seem like the
              final chapter of college life, but the story leading up to this is
              full of twists, turns, characters, and plots from which you can
              learn a lot. It’s important to remember that this isn’t the
              endgame of life. From my own experience, these insights can make a
              difference if you know them beforehand. I hope some parts of my
              journey, which I shared, and the lessons I’ve learned along the
              way can help guide you through your own placement process.
            </p>
          </div>
        </div>
        <img
          class="blog-image-right"
          src="placement-postulates/blogs/Shubham-kumar/1.jpg"
          alt="Shubham"
        />

        <div className="row blog-row">
          <div className="col-md-12">
            <h3>What role should I go for in the placements?</h3>
            <p>
              By the end of my fifth semester, I was still clueless about which
              role to aim for in placements. However, working and being
              appreciated as the design secretary for clubs, festivals, and
              societies had given me graphic design skills back in my second
              year. I gained hands-on experience with posters, graphics, and
              website UIs and soon found myself really enjoying graphic design
              (and now even thinking of starting a company). This even landed me
              a paid opportunity through Internshala (yes, you can find
              internships and jobs there too!). Serving as the coordinator for
              the Society of Civil Engineers, organizing events, and taking
              initiatives, while also unofficially designing posters for cells
              and fests, collectively taught me a lot about team and event
              management and boosted my design skills. This led to two more
              off-campus paid opportunities at early-stage startups through
              LinkedIn.
            </p>

            <p>
              When the sixth semester ended, summer break arrived with
              opportunities for students to do internships and start hard-core
              preparation for placements. Like most civil engineering students,
              I couldn't secure an internship through the SPO internship drive
              because I wasn't sure about which role to pursue at that time (I
              had a CPI of exactly 7 during the drive) and, honestly, my
              preparation wasn't great. On-campus hiring for civil engineering
              interns through the SPO drive usually falls below 20 for
              undergraduates, possibly because companies prefer circuital
              branches, or maybe because most roles were SDE positions, or maybe
              lack of preparation due to undecided roles.
            </p>
            <p>
              As summer break began, I found myself without an internship. I
              decided to buckle down and seriously prepare for placements,
              consulting lots of seniors, including my baapu Tathagat Patel
              (Y19, BS-Eco), other seniors like Sanskar Shah (Y19, CE), and many
              friends. Their advice helped me a lot in deciding the role and
              path for placements. My roommate, Kumar Abhishek (who switched
              from civil to mechanical in the fourth semester), got a data
              science internship at Dr. Reddy's Laboratories. He advised me to
              try learning data science and prepare for it. He gave me some
              YouTube playlists and documents that turned out to be really good.
              I got interested in the field, learned advanced concepts, and
              started working on projects to add to my resume. After a month and
              a half, I felt confident in data science and even helped Kumar
              with his internship project as well.
            </p>
            <p>
              Product roles appealed to me because they required creativity and
              innovative thinking. My experience handling teams, designing, and
              taking initiatives as a coordinator made me feel ready for this
              role. During the summer break, I prepared for placements and
              applied for internships on websites, LinkedIn, and even through
              cold emails. I secured an off-campus offer for graphic design and
              another offer from a startup through LinkedIn for the role of
              product developer. Working closely with founders and multiple
              teams and solving issues for the company got me a pre-placement
              offer by the end of summer break, which made me a bit relaxed. But
              I kept preparing for placements, hoping to secure a better offer
              in the SPO placements. Including preparation for the targeted
              roles, I, along with Ajeet Kushwaha (Y20, CE) and Kumar Abhishek,
              practiced aptitude tests, puzzles, and guesstimates on multiple
              websites at a constant pace.
            </p>
            <p>
              I'll admit, I never really prepared hard for a core civil
              engineering role and never planned to work in the core sector. But
              I did a project in machine learning that can be used in civil
              engineering. I also went on a field trip, or summer camp, and got
              some hands-on experience in geoinformatics. I was also the
              coordinator of the Society of Civil Engineers, was organizing
              Sankalan (a national-level civil engineering conclave), and had a
              basic understanding of core civil subjects thanks to last-minute
              cramming before quizzes and exams, which surprisingly helped in
              placements. So, I thought of at least applying for the core role
              as one of the options if nothing else worked. After going through
              all these experiences, I finally decided on my roles before
              submitting my resume.
            </p>
          </div>
        </div>

        <div className="row blog-row">
          <div className="col-md-12">
            <h3>Resume, Aptitudes, and Interviews:</h3>
            <p>
              During the resume submission for placements, I had prepared my
              resumes for data science, product, and core roles, including
              considerable projects, field trips, and internships. However, my
              CPI, which had always been above 7, fell to 6.9. This made me
              really tense and worried, knowing I'd lose some opportunities.
              Unfortunately, this actually happened, and it will always be a
              regret. So, I started applying to almost all the companies coming
              in; as being non-circuital, there was no harm in trying. However,
              I attended only company- and profile-specific PPTs.
            </p>
            <p>
              Everyone was making their resumes and feeling the pressure of
              placements. One day, my friend came extremely worried, saying the
              market condition was not good, and given our civil engineering
              background and limited preparation, we were unsure if we’d get
              placed. These were constant talks and thoughts in every group at
              that moment. Aptitude tests began in August, and we started
              appearing in all of them wherever we got the opportunity. After
              every test, we felt exhausted but kept returning to the lecture
              halls daily. It became a routine: waking up, running for an
              aptitude test, getting back to the room, and ranting about
              placements. After giving more than 20 aptitude tests, I was
              confident about clearing a few of them. However, some companies
              applied a CPI criterion of above 7 for interviews, and I missed a
              few opportunities despite doing well on the tests.But I qualified
              for interviews with companies like Finmechanics, Blitz, Future
              First, Axxela, Reliance Industries, FN Mathlogic, Transorg
              Analytics, Larsen & Toubro, and Ceigall India.
            </p>
            <p>
              This year's job placements were quite disappointing. Many
              companies either didn't show up or were hiring very few people at
              lower salaries. Even though some students found jobs, they often
              ended up in roles they hadn't originally aimed for. For instance,
              those preparing to be software developers ended up working in
              trading firms because there were fewer openings for software
              developers and similar for other roles as well. Overall, some
              people didn't get their first-choice jobs due to tough placement
              conditions. I had interviews from days 1.1, 3.1, 3.2, till the
              last day of placements. The most patience-testing moment for me
              was the Day 3 Blitz interview. It had three rounds: a resume
              screening and two technical rounds, each lasting 40 minutes to an
              hour. I qualified for each round, one by one, among the 60
              students. By 4:30 PM, I had cleared all the rounds, starting
              around noon, and I was confident about getting an offer. But there
              were long gaps between the interviews of other candidates, and the
              final result was not announced immediately, which made me panic.
              There was a lot of politics involved, as the interviewers were our
              own alumni and known by many students. This worried me about
              whether it would affect my selection, and it actually did.
            </p>
            <p>
              Meanwhile, at 5 PM, I was informed that the Axxela interview,
              scheduled for the next day, was rescheduled for 5 PM. I wasn't
              prepared for this and didn't want to leave the Blitz interview
              floor, but my friends convinced me to attend the Axxela interview.
              When we got there, another level of politics was happening.
              Interviews were scheduled very unplanned; those who came early
              were interviewed first, and then the process stopped. This led to
              a heated argument between students and SPO, causing further
              delays. I was finally interviewed late at night but left midway to
              return to Blitz. After 12 hours of waiting, I was informed at
              midnight that I was not selected for Blitz, possibly due to some
              dirty politics or unknown reasons. Leaving Hall 12 at the end of
              Day 3 without getting placed, despite giving my best, led to a
              breakdown. Seeing my condition, even my friends became emotional,
              but they helped me regain confidence to appear in the next
              interviews. I was demotivated for a few days and didn't do well,
              but I kept trying, reaching the final rounds in other interviews
              but still not getting selected.
            </p>
            <p>
              Then Larsen & Toubro, which had conducted its aptitude test a
              month ago, sent me an email scheduling the interview early in the
              morning. The evening before the interview, I consulted seniors
              already placed in the company about the types of questions they
              ask. I revised some aptitude questions and civil engineering
              concepts from random engineering websites. The interview focused
              on civil engineering questions ranging from structural,
              geoinformatics, geotechnical, and environmental. They also asked
              about my achievements and contributions in college, where I
              explained my positions of responsibility and initiatives. The
              final question was a speech on an inspiring personality, and I
              spoke about Dr. B.R. Ambedkar. By the end of the day, the result
              was announced on the portal, and only two candidates from MSE and
              EE were selected. My name was not on the list. This demotivated me
              a lot, but in the end, I accepted my fate and thought of trying in
              Phase II.
            </p>
          </div>
        </div>
        <br />
        <br />
        <br />
        <img class="blog-image-right"
        src="placement-postulates/blogs/Shubham-kumar/2.jpg"
        alt="Shubham"
        />
        <div className="row blog-row">
          <div className="col-md-12">
            <h3>Prayers worked:</h3>
            <p>
              I started my placement journey with a group of friends (Ajeet,
              Kumar, Nidhi, Sahil, and Saurabh). While most of them got placed,
              one friend and I were still struggling. As the days went by
              without any offers, I started losing hope of getting placed in the
              first phase. Initially, our group was confident that we would all
              get placed early and then go on a trip to Banaras. However, things
              didn't go as planned, and due to not getting placed, we had to
              cancel our plans.
            </p>
            <p>
              To break the gloomy atmosphere and bring some positive vibes, we
              decided to visit the ISKCON temple. We prayed to get placed as
              soon as possible. After leaving the temple, my friends tried to
              cheer me up, and I tried my best to stay happy, but internally, I
              was sad. Then, like a movie scene with a happy ending, I suddenly
              got a call from the APC informing me that I was selected by Larsen
              & Toubro as a management trainee. This call made my day, as
              getting placed in Phase I was such a relief. The next day, my
              other friend, who was also struggling, received a message that he
              also got a placement. Finally, the group with which I started my
              placement journey was all placed.
            </p>
            <p>
              That's how the first phase of placements ended, with all of us
              finally getting placed. I think the prayers worked. And yes, we
              went on our much-awaited Banaras trip in January. After conducting
              the conclave (Sankalan) and getting placed, I enjoyed the rest of
              my days on campus a lot. I went on multiple trips, explored
              Kanpur, visited clubs, performed in Dance Extravaganza, and
              partied daily. Each day was so much fun, with no more pressure on
              my mind. There are lots of things related to placements and many
              stories I could share, but I'll stop here before this turns into a
              novel.
            </p>
          </div>
        </div>
        <img class="blog-image-right"
        src="placement-postulates/blogs/Shubham-kumar/4.jpg" 
        alt="Shubham"
        />
        <div className="row blog-row">
          <div className="col-md-12">
            <h3>General Placement Gyan:</h3>
            <p>
              The placement process starts in August with resume submission,
              followed by aptitude tests in September, and Phase I concludes
              with interviews in December. Companies hire for various roles such
              as trading, quant, analyst, consulting, data science, product
              manager, associate, trainee, core engineering roles, and more. The
              hiring process is generally similar across different roles. You
              can find company performas on the SPO website and statistics of
              placements from SPO coordinators and seniors.
            </p>
            <p>
              Here's a streamlined guide to the placement process:
              <ul>
                <li>
                  <h5>1.PPTs and Company Information:</h5>
                  <p>
                    Companies start organizing their PPTs in July or August,
                    both offline and online.
                  </p>
                  <p>
                    Attend these to understand the company's details and work
                    culture. SPO takes attendance and shares it with companies,
                    it may not significantly impact the process, but it's safer
                    to attend the PPTs.
                  </p>
                </li>
                <li>
                  <h5>2.Resume and Portal Registration:</h5>
                  <p>
                    Email your master resume for verification by the POC; any
                    discrepancies will be addressed.
                  </p>
                  <p>
                    Register on the RAS Portal, verify details, and pay the fee
                    (Rs. 1500/-).
                  </p>
                  <p>
                    Submit up to five resumes (single or double-page) on the
                    placement portal, derived from your master resume. These
                    resumes will be used for applications.
                  </p>
                </li>
                <li>
                  <h5>3.Application Process:</h5>
                  <p>
                    Once SPO starts listing companies, those open to you will be
                    shown on your portal, and you can apply accordingly.
                  </p>
                  <p>
                    You may need to fill out additional forms or use
                    company-specific portals, as mentioned in the notices.
                  </p>
                  <p>
                    Most companies are open to all branches but may have a CPI
                    criterion (usually 7 or 7.5). Don't worry if your CPI is
                    below 7; there will still be plenty of opportunities.
                  </p>
                  <p>
                    50-Company Rule: This rule pertains to 50 companies, not 50
                    applications or profiles, and is applicable until around the
                    first week of November. Non-circuital branch students need
                    not be overly concerned about this rule. The SPO portal
                    shows the count of applications and profiles, not companies.
                  </p>
                </li>
                <li>
                  <h5>4.Aptitude Tests</h5>
                  <p>
                    Aptitude tests are mostly offline in lecture halls using
                    your own laptop. Bring essentials like a notebook, water
                    bottle, and extension cord.
                  </p>
                  <p>
                    Tests are conducted on platforms like HackerEarth,
                    HackerRank, Mettl, etc.
                  </p>
                  <p>
                    You may need to take several tests and assignments if you've
                    applied to many companies.
                  </p>
                </li>
                <li>
                  <h5>5.Interviews</h5>
                  <p>
                    Shortlists for interviews are communicated a week or less
                    before Day 1 starts.
                  </p>
                  <p>
                    Acquire formal attire (suits and all), which you can buy
                    from campus vendors or bring your own.
                  </p>
                  <p>
                    Interviews will be offline in Hall 12 in various blocks,
                    starting at midnight on November 30.
                  </p>
                  <p>
                    Interview days are divided into parts like 1.1, 1.2, 2.1,
                    2.2, and so on.
                  </p>
                  <p>
                    Keep a bag with your laptop and multiple copies of your
                    resume ready.
                  </p>
                  <p>
                    For subsequent interview rounds, information will be on the
                    RAS portal or communicated by Company-Coordinators and APCs.
                    Don't leave the block unless instructed by SPO.
                  </p>
                  <p>
                    Some companies may conduct walk-in interviews, which will
                    (may) be announced on the RAS portal.
                  </p>
                </li>
                <li>
                  <h5>6.Preparation Tips</h5>
                  <p>
                    Prepare along with friends to maintain a constant schedule
                    and motivate each other for improvements.
                  </p>
                  <p>
                    Make and learn from good projects with real-world
                    applications and a unique aspect. Gain actual skills and
                    have an in-depth understanding of your projects.
                  </p>
                  <p>
                    The interview floor will be hectic, so stay focused (it's
                    entirely possible that people you never expected might get
                    placed before you but just keep focusing on yourself.),
                    revise your resume constantly, and know every word with deep
                    understanding.
                  </p>
                  <p>
                    Seek help from any legitimate source available, and stay
                    active during the placement semester.
                  </p>
                  <p>
                    Prioritize your daily schedule to balance aptitude tests,
                    interviews, meals, health, and proper sleep.
                  </p>
                </li>
              </ul>
            </p>
          </div>
        </div>

        <div className="row blog-row">
          <div className="col-md-12">
            <h3>Dark Realities in Placement Processes:</h3>
            <p>
              From resume submission to interviews, every step in the placement
              process seems to have loopholes that some students exploit. They
              fake projects, internships, or research they never did, often with
              the help of club coordinators who validate these false claims.
              Some even manipulate their CPI on resumes and portals.
            </p>
            <p>
              During aptitude tests in lecture halls, cheating becomes almost
              organized. Students arrive early to secure strategic seats for
              coordinated cheating via discussions and WhatsApp groups. Some
              portals can't detect tab switches or phone use, and invigilators,
              who are fellow students like Company Coordinators or APCs, often
              turn a blind eye. For assignments, some students leverage
              connections to have experts complete the work for them. Interviews
              are no different. Insiders sometimes slip their friends' names
              onto interview lists or unfairly push for their selection. Walk-in
              interview information might not reach the RAS portal immediately
              and is often first shared with the well-connected through SPO.
              Alumni with connections to interviewing HR can also influence
              outcomes.
            </p>
            <p>
              At every step, some people bend the rules to their advantage.
              Unfortunately, some officials turn a blind eye or even support
              these practices instead of reporting them. Not all officials are
              involved, but a few operate in secrecy. These shady practices seem
              to be accepted as normal and benefit many, leaving honest students
              at a disadvantage. Be prepared for these scenarios, and remember
              that every action, whether right or wrong, has a significant
              impact on the outcomes. As you go through the placement process,
              keep your determination strong. Prepare diligently, showcase your
              skills and accomplishments genuinely. Success may not be
              immediate, but staying committed and making the most of every
              opportunity will set you apart. Stay positive, believe in
              yourself, and approach each challenge with confidence. All the
              best for your placements!
            </p>
          </div>
        </div>
        <img class="blog-image-right"
        src="placement-postulates/blogs/Shubham-kumar/7.jpg"
        alt="Shubham" />
        <div className="row blog-row">
          <div className="col-md-12">
            <h3>Resources:</h3>
            <p>
              <ul>
                <li>
                  <b>Probability:</b> Refer to the original book and this
                  <a
                    href="https://www.youtube.com/playlist?list=YOUR_PLAYLIST_ID"
                    className="resume-link"
                  >
                    YouTube playlist
                  </a>
                  .
                </li>
                <li>
                  <b>Aptitude:</b> Practice General and Verbal Aptitude:
                  <a href="https://www.indiabix.com" className="resume-link">
                    IndiaBix
                  </a>
                  .
                </li>
                <li>
                  <b>Quick Math:</b> Daily Practice:
                  <a href="https://www.tradermath.com" className="resume-link">
                    Trader Math
                  </a>{" "}
                  or
                  <a
                    href="https://www.optiver.com/80-in-8-test"
                    className="resume-link"
                  >
                    Optiver 80-in-8 Test
                  </a>
                  .
                </li>
                <li>
                  <b>Puzzles:</b> Learn Patterns:
                  <a
                    href="https://www.brainstellar.com/puzzles"
                    className="resume-link"
                  >
                    Brainstellar Puzzles
                  </a>{" "}
                  or
                  <a
                    href="https://www.youtube.com/playlist?list=YOUR_PLAYLIST_ID"
                    className="resume-link"
                  >
                    Puzzles Playlist
                  </a>
                  .
                </li>
                <li>
                  <b>Guesstimates/Case Study:</b>
                  <a
                    href="https://www.caseinterviewscracked.com"
                    className="resume-link"
                  >
                    Case Interviews Cracked
                  </a>
                  .
                </li>
                <li>
                  <b>SQL:</b>
                  <a
                    href="https://www.learnsqlin1hour.com"
                    className="resume-link"
                  >
                    Learn SQL in 1 Hour
                  </a>
                  .
                </li>
                <li>
                  <b>Power BI/Tableau:</b>
                  <a href="https://www.codebasics.io" className="resume-link">
                    Codebasics
                  </a>
                  : Search for relevant tutorials.
                </li>
                <li>
                  <b>Data Science:</b> Start with Basics:
                  <a
                    href="https://www.introductiontodatascience.com"
                    className="resume-link"
                  >
                    Introduction to Data Science
                  </a>
                  .
                </li>
                <li>
                  <b>Convolutional Neural Networks (CNN):</b>
                  <a
                    href="https://www.youtube.com/playlist?list=YOUR_PLAYLIST_ID"
                    className="resume-link"
                  >
                    YouTube Playlist
                  </a>
                  .
                </li>
                <li>
                  <b>Natural Language Processing (NLP):</b>
                  <a
                    href="https://www.youtube.com/playlist?list=YOUR_PLAYLIST_ID"
                    className="resume-link"
                  >
                    YouTube Playlist
                  </a>
                  .
                </li>
                <li>
                  <b>Langchain:</b>
                  <a
                    href="https://www.youtube.com/playlist?list=YOUR_PLAYLIST_ID"
                    className="resume-link"
                  >
                    YouTube Playlist
                  </a>
                  .
                </li>
                <li>
                  <b>Large Language Models (LLM):</b> Start building projects
                  and continue learning.
                </li>
                <li>
                  <b>Resume:</b>
                  <a
                    href="https://www.shubhamkumar.com/resume"
                    className="resume-link"
                  >
                    Shubham Kumar
                  </a>
                  .
                </li>
                <li>
                  <b>Contact:</b>
                  <a
                    href="https://www.linkedin.com/in/shubhamkumar"
                    className="resume-link"
                  >
                    LinkedIn: Shubham Kumar
                  </a>
                  .
                </li>
              </ul>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Shubham;